import { HttpHeaders } from '@angular/common/http';
import {
  Component,
  OnInit,
  Output,
  EventEmitter,
  OnDestroy,
} from '@angular/core';
import { RequestService } from '../service/request.service';
import { GetterService } from '../service/getter-service.service';
import { ApiService } from '../service/api.service';
import { Subscription } from 'rxjs';
import { Category, SubCategory } from 'src/Model/Product-Interfaces';
import { ActivatedRoute } from '@angular/router';
import * as webCustomer from '../../Model/WebCustomer';
import { environment } from 'src/environments/environment';
import { PosthogService } from '../analytics/services/posthog.service';
import { ThemeService } from '../service/theme.service';
import { uiExpand, uiToggle } from '../shared/ui-collapse';
import { brandFlavor, pageSegment } from 'src/app/brand/brand-context';
export interface SideMenuData {
  cat: Category;
  subCat: SubCategory;
}
@Component({
  selector: 'app-side-drawer',
  templateUrl: './side-drawer.component.html',
  styleUrls: ['./side-drawer.component.scss'],
})
export class SideDrawerComponent implements OnInit, OnDestroy {
  selectedSubCat: number;
  brandFlavour: string;
  brand_Categories;
  selectedCatId: number;

  /* brands without a Theme keep their DynamicStyle button colour (see ThemeService.legacyAccentVars) */
  accentVars: Record<string, string> | null = null;

  ProductSideMenu: webCustomer.ProductSideMenu;

  @Output() closeSideCat = new EventEmitter<boolean>();
  template: string;
  subs: Subscription[] = [];
  currentComponent: string;
  catId: number;
  ProductionEnvironment: boolean;

  counters: Counters = { cats: {}, subCats: {} };
  brandId: number;

  constructor(
    private _requestService: RequestService,
    private apiService: ApiService,
    private route: ActivatedRoute,
    private posthog: PosthogService,
    private theme: ThemeService
  ) {}

  ngOnInit(): void {
    this.ProductionEnvironment = environment.production;
    this.currentComponent = pageSegment();
    this.currentComponent = this.currentComponent.split('?')[0];
    this.brandFlavour = brandFlavor();

    this.getWebCustomer();
    this.resetCategories();
  }

  ngOnDestroy(): void {
    this.subs.forEach((sub) => sub.unsubscribe());
  }

  resetCategories() {
    const sub = this._requestService.resetSideCats.subscribe(() => {
      this.catCliked(this.brand_Categories[0]);
    });
    this.subs.push(sub);
  }

  getWebCustomer() {
    const sub = this.apiService.getWebcustomer$.subscribe((res) => {
      if (!res) {
        return;
      }
      this.brandId = res.BrandData.BrandId;
      this.template = res.TemplateData.TemplateType;
      this.accentVars = this.theme.legacyAccentVars(res);

      this.ProductSideMenu =
        res.TemplateData.DynamicProductSideMenu?.ProductSideMenu;

      this.catId = +this.route.snapshot.queryParams['catId'];
      if (this.template == 'Stellar') {
        this.getCategories();
      }

      if (this.ProductSideMenu?.ShowCounters) this.getCatCounters();
    });
    this.subs.push(sub);
  }

  getCategories() {
    const body = { OnlineOrderingEnabledCategory: true };
    this._requestService
      .postRequest(
        `api/Category/v1/getCategories/${this.brandFlavour}/Product`,
        body
      )
      .subscribe({
        next: (res) => {
          if (res['Info']['Status'] == 200) {
            this.brand_Categories = res['Data'];

            this.brand_Categories = this.brand_Categories.map((c) => {
              c.Subcategories = c.Subcategories?.filter((s) => s.Status);
              return c;
            });

            if (this.currentComponent != 'store') {
              this.openCat(this.brand_Categories[0]);
              return;
            }
            if (this.currentComponent == 'store') {
              if (this.catId) {
                const cat = this.brand_Categories.find(
                  (cat) => cat.CategoryId == this.catId
                );

                this.catCliked(cat);
                this.catId = 0;
                return;
              }

              this.catCliked(this.brand_Categories[0]);
            }
          }
        },
      });
  }

  catCliked(cat) {
    this.selectedCatId = cat.CategoryId;
    this.expandCat(cat);
    var data = {
      cat: cat,
      subCat: null,
    };
    this._requestService.sideCatClicked.next(data);
    this.closeSideCat.emit(false);
    this.posthog.captureEvent('side_drawer_category_clicked', {
      categoryId: cat.CategoryId,
      categoryName: cat.CategoryName
    });
  }

  openCat(cat, event?) {
    event?.stopPropagation();
    var data = {
      cat: cat,
      subCat: null,
    };

    this._requestService.sideCatChanged.next(data);
    if (!cat.Subcategories?.length) {
      this.closeSideCat.emit(false);
    }
    this.selectedCatId = cat.CategoryId;
    this.selectedSubCat = cat?.Subcategories[0]?.SubcategoryId;
    this.expandCat(cat);
  }

  trackCategory = (_: number, c: any) => c?.CategoryId;

  /* accordion: Bootstrap animates, Angular decides (one owner of the state) */
  expandCat(cat) {
    if (!cat?.Subcategories?.length) return;
    setTimeout(() => uiExpand('drawer-cat-' + cat.CategoryId, '#catnav-drawer'));
  }

  toggleCat(cat) {
    if (!cat?.Subcategories?.length) return;
    uiToggle('drawer-cat-' + cat.CategoryId, '#catnav-drawer');
  }

  openSubCat(cat, subCat, event?) {
    event?.stopPropagation();
    var data = {
      cat: cat,
      subCat: subCat,
    };
    this.selectedSubCat = subCat.SubcategoryId;
    this.expandCat(cat);
    this._requestService.sideCatChanged.next(data);
    this.closeSideCat.emit(false);
    this.posthog.captureEvent('side_drawer_subcategory_clicked', {
      categoryId: cat.CategoryId,
      categoryName: cat.CategoryName,
      subCategoryId: subCat.SubcategoryId,
      subCategoryName: subCat.SubcategoryName
    });
  }

  getCatCounters() {
    this._requestService
      .getRequest(`api/Category/getCategoriesProductCounters/${this.brandId}`)
      .subscribe({
        next: (res) => {
          if (res.Info.Status == 200) {
            this.counters.subCats = res.Data.SubCatCounts;
            this.counters.cats = res.Data.CatCounts;
          }
        },
        error: (e) => {},
      });
  }
}

interface Counters {
  cats: { [key: number]: number };
  subCats: { [key: number]: number };
}
